import { z } from 'zod';
import { MemberWithAccountStatus } from './member';

/**
 * Admin Types
 * 
 * Type definitions for admin operations including member management,
 * invitations, and administrative controls.
 */

// Validation Schemas
export const inviteMemberSchema = z.object({
  email: z.string().email('Invalid email format'),
  firstName: z.string().min(1, 'First name is required'),
  surname: z.string().min(1, 'Surname is required')
});

export const reinviteMembersSchema = z.object({
  memberIds: z.array(z.number().int().positive('Member ID must be a positive integer')).min(1, 'At least one member ID is required')
});

export const registerMemberSchema = z.object({
  hub: z.string().min(1, 'Hub name is required'),
  userEmail: z.string().email('Invalid user email format'),
  email: z.string().email('Invalid email format'),
  isAdmin: z.boolean().optional()
});

export const updateAdminStatusSchema = z.object({
  memberIds: z.array(z.number().int().positive('Member ID must be a positive integer')).min(1, 'At least one member ID is required'),
  isAdmin: z.boolean()
});

export const toggleActiveStatusSchema = z.object({
  memberIds: z.array(z.number().int().positive('Member ID must be a positive integer')).min(1, 'At least one member ID is required'),
  isActive: z.boolean()
});

// Input Types (inferred from schemas)
export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;
export type ReinviteMembersInput = z.infer<typeof reinviteMembersSchema>;
export type RegisterMemberInput = z.infer<typeof registerMemberSchema>;
export type UpdateAdminStatusInput = z.infer<typeof updateAdminStatusSchema>;
export type ToggleActiveStatusInput = z.infer<typeof toggleActiveStatusSchema>;

// Result Types
export interface InviteMemberResult {
  message: string;
  memberId?: number;
}

export interface ReinviteMembersResult {
  message: string;
}

export interface UpdateAdminStatusResult {
  message: string;
  affectedCount: number;
}

export interface ToggleActiveStatusResult {
  message: string;
  setToActive: boolean;
  affectedCount: number;
}

export interface AdminListMembersResult {
  members: MemberWithAccountStatus[];
}

export interface RegisterMemberResult {
  message: string;
  member: MemberWithAccountStatus;
}